<template>
  <div>
    <ButtonGroup
      v-if="displayStyle === 'buttonGroup'"
      class="text-xs h-12 sm:h-8"
    >
      <button
        v-for="method in pricingMethods"
        :key="method.id"
        class="grow pb-0"
        data-test-id="pricing_type_filter"
        :class="{'is-active': priceMethod === method.id}"
        @click="$emit('change', method.id)"
      >
        {{ method.label }}
        <br class="sm:hidden">
        ({{ metaPricingMethodCounter[method.id] }})
      </button>
    </ButtonGroup>

    <div
      v-if="displayStyle === 'radioGroup'"
      class="mb-4"
    >
      <p class="text-sm">
        Pricing for hiring the space:
      </p>

      <RadioGroup :value="priceMethod || 'all'">
        <RadioField
          val="all"
          :model-value="priceMethod === null ? 'all' : priceMethod"
          name="All"
          label="All pricing methods"
          @update:modelValue="$emit('change', null)"
        />
        <RadioField
          v-for="method in pricingMethods"
          :key="method.id"
          :val="method.id"
          :model-value="priceMethod"
          :name="method.label"
          :label="`${method.labelLong || method.label} (${metaPricingMethodCounter[method.id]})`"
          @update:modelValue="$emit('change', method.id)"
        />
      </RadioGroup>
    </div>

    <p
      v-if="selectedPriceMethod"
      class="text-xs text-grey-600 mt-2 mb-0"
    >
      <strong class="font-semibold">
        {{ selectedPriceMethod.label }}
      </strong>
      –
      {{ selectedPriceMethod.description }}
    </p>
  </div>
</template>

<script>
import RadioField from '@/components/Ui/Forms/RadioField.vue';
import RadioGroup from '@/components/Ui/Forms/RadioGroup.vue';
import ButtonGroup from '@/modules/public/search/components/SearchFilters/components/ButtonGroup.vue';

export default {
  name: 'PriceMethods',
  emits: ['change'],
  components: { RadioField, RadioGroup, ButtonGroup },
  props: {
    metaPricingMethodCounter: {
      type: Object,
      required: true,
    },
    priceMethod: {
      type: String,
      default: '',
    },
    pricingMethods: {
      type: Array,
      required: true,
    },
    displayStyle: {
      type: String,
      validator: (style) => ['buttonGroup', 'radioGroup'].includes(style),
      required: true,
    },
  },

  computed: {
    selectedPriceMethod() {
      return this.pricingMethods.find(method => this.priceMethod === method.id);
    },
  },
};
</script>
